import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Button, Tooltip } from "../../common/UIComponents";
import I18n from "../../common/I18n";
import BillingPdfDownload from "./BillingPdfDownload";

// Shared Reset / Regenerate / Send Billing / Download-Print button group used by
// both the Billing screen header (Header.jsx) and the Order-screen Estimate tab
// (InvoiceForm's LoS row). Visibility of each action is driven by the caller so
// each screen keeps its own conditions; the markup/handlers live here once.
const BillingActionButtons = ({
  showReset = false,
  showRegenerate = false,
  showSendBilling = true,
  showDownload = false,
  regenerateLabel = "Regenerate",
  regenerateIcon = "form",
  onReset,
  onRegenerate,
  onSendBilling,
  isLocked = false,
  isSendingMail = false,
  selectedKeys = [],
  retrivePreviewDetails,
  screenFrom = "form-details",
  downloadParams,
  size = "small",
}) => {
  // v2 button hierarchy: Recalculate/Regenerate is the primary brand-filled CTA;
  // Reset / Send Billing / Download are brand-outline (ghost) secondary actions.
  const brandPrimary = {
    backgroundColor: "var(--lp-color-brand-500)",
    borderColor: "var(--lp-color-brand-500)",
    color: "#fff",
  };
  const brandGhost = {
    backgroundColor: "#fff",
    borderColor: "var(--lp-color-brand-500)",
    color: "var(--lp-color-brand-500)",
  };
  return (
  <Fragment>
    {showReset && (
      <Button
        size={size}
        disabled={isLocked}
        onClick={onReset}
        className="fontSize13 cursorPointer textBold marginRight5"
        style={brandGhost}
        icon="redo"
      >
        Reset
      </Button>
    )}
    {showRegenerate && (
      <Button
        data-testid="regenerate-button"
        type="primary"
        size={size}
        disabled={isLocked}
        onClick={onRegenerate}
        className="fontSize13 cursorPointer textBold marginRight5"
        style={brandPrimary}
        icon={regenerateIcon}
      >
        {regenerateLabel}
      </Button>
    )}
    {showSendBilling && (
      <Tooltip title={I18n.t("general.send_item", { item: I18n.t("invoices.billing") })}>
        <Button
          data-testid="send-billing-button"
          type="link"
          size={size}
          icon="mail"
          onClick={onSendBilling}
          loading={isSendingMail}
          className="cursorPointer marginRight5"
          style={{ color: "var(--lp-color-brand-500)", fontSize: 24, padding: 0 }}
        />
      </Tooltip>
    )}
    {showDownload && (
      <BillingPdfDownload
        buttonType="link"
        size={size}
        style={{ color: "var(--lp-color-brand-500)", fontSize: 24, padding: 0 }}
        label=""
        tooltip={"Download / " + I18n.t("general.print")}
        isDisabled={(selectedKeys?.length || 0) === 0}
        handleSuccess={() => {}}
        orderIds={selectedKeys ? [...selectedKeys] : []}
        retrivePreviewDetails={retrivePreviewDetails}
        screenFrom={screenFrom}
        params={downloadParams}
      />
    )}
  </Fragment>
  );
};

BillingActionButtons.propTypes = {
  showReset: PropTypes.bool,
  showRegenerate: PropTypes.bool,
  showSendBilling: PropTypes.bool,
  showDownload: PropTypes.bool,
  regenerateLabel: PropTypes.string,
  regenerateIcon: PropTypes.string,
  onReset: PropTypes.func,
  onRegenerate: PropTypes.func,
  onSendBilling: PropTypes.func,
  isLocked: PropTypes.bool,
  isSendingMail: PropTypes.bool,
  selectedKeys: PropTypes.array,
  retrivePreviewDetails: PropTypes.func,
  screenFrom: PropTypes.string,
  downloadParams: PropTypes.object,
  size: PropTypes.string,
};

export default BillingActionButtons;
